import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import useResponsive from '@/hooks/useResponsive';
import { RootState } from '@/redux/store';

const useLayout = () => {
  const isSmallScreen = useResponsive('down', 'lg');
  const [openDrawer, setOpenDrawer] = useState(!isSmallScreen);
  const [openBalanceDrawer, setOpenBalanceDrawer] = useState(false);
  const [handle_el, setAnchorEl] = useState<null | any>(null);
  const [option, setOption] = useState<string>('');

  const toggleDrawer = useCallback(() => setOpenDrawer(!openDrawer), [openDrawer]);

  const toggleBalanceDrawer = useCallback(
    () => setOpenBalanceDrawer(!openBalanceDrawer),
    [openBalanceDrawer],
  );

  const closeDrawer = useCallback(() => setOpenDrawer(false), []);

  const closeDrawerOnMobile = useCallback(() => {
    if (isSmallScreen) {
      setOpenDrawer(false);
    }
  }, [isSmallScreen]);

  const { balance, profile } = useSelector((state: RootState) => state.parcel);

  const handleOpenUserMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  const handleOption = (option: string) => {
    setOption(option);
  };

  return {
    handle_el,
    openDrawer,
    openBalanceDrawer,
    handleOpenUserMenu,
    handleCloseUserMenu,
    toggleDrawer,
    toggleBalanceDrawer,
    balance,
    profile,
    option,
    handleOption,
    isSmallScreen,
    closeDrawer,
    closeDrawerOnMobile,
  };
};

export default useLayout;
